import type { PageGuide } from "../page-guide.js";

/** Help guide for a project data room built before the companies are incorporated. */
export const dataRoomsGuide: PageGuide = {
  route: "/data-rooms",
  version: 1,
  overviewArticleId: "data-rooms-overview",
  steps: [
    {
      id: "create",
      title: "Create a room",
      body: "Choose the project and use **Create room**. The room belongs to that project.",
    },
    {
      id: "entity",
      title: "Add a proforma entity",
      body: "Use **Add entity** with a working name and Pakistan or the UAE. Use **Record formation** on that same entity when the legal name, registration number, and date exist.",
    },
    {
      id: "evidence",
      title: "Admit evidence",
      body: "Use **Admit** to add a title. It starts held. **Release** and **Hold** stay inside the room and do not invite an investor.",
    },
  ],
  panels: [],
  guidedActions: [],
};
